<section role="region" fxLayout="column" fxLayoutAlign="center center" aria-labelledby="errorhead">
  <h1 id="errorhead">Error: 404</h1>
  <p>Page not found</p>
</section>
